import { env } from "../../../config/env";
import { apiClient } from "../../config";

import {
  GetProductsResponse,
  GetProductResponse,
} from "../../interface/products.interface";

import {
  GetProductCategoriesResponse,
} from "../../interface/productcategories.interface";

class ProductsService {
  /**
   * 🛒 GET PRODUCTS
   */
  async getProducts(): Promise<GetProductsResponse> {
    const response = await apiClient.get<GetProductsResponse>(
      env.PUBLIC_PRODUCTS_URL
    );

    return response.data;
  }

  /**
   * 📄 GET PRODUCT
   */
  async getProduct(id: string): Promise<GetProductResponse> {
    const response = await apiClient.get<GetProductResponse>(
      env.PUBLIC_PRODUCT_URL(id)
    );

    return response.data;
  }

  /**
   * 🧩 GET PRODUCT CATEGORIES
   */
  async getProductCategories(): Promise<GetProductCategoriesResponse> {
    const response = await apiClient.get<GetProductCategoriesResponse>(
      env.PUBLIC_PRODUCT_CATEGORIES_URL
    );

    return response.data;
  }
}

export const publicProductsService = new ProductsService();